import axios from 'axios';

import Services from './index.service';

export default class MisplacementProcedureService extends Services<any, any> {

  async putLossFlowApproval(data: any) {
    return await axios
      .put(`${this.base_url}/ticket/loss-flow-approval`, data, {
        headers: { Authorization: `Bearer ${this.access_token()}` },
      })
      .then((result) => result)
      .catch((err) => err.response);
  };
}